var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressbar"},[_c('div',{staticClass:"progressbar-inner",style:(`width: ${_vm.progressbarWidth}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }